const state = {
  isOpen: false,
  mode: "manual",
  recipients: [],
  query: {},
}

const getters = {
  smsDialog(state) {
    return state;
  },
  isOpen(state) {
    return state.isOpen;
  },
  mode(state) {
    return state.mode;
  },
  recipients(state) {
    return state.recipients;
  },
  query(state) {
    return state.query;
  },
}

const actions = {
  closeSMSDialog({ commit }) {
    commit("setRecipients", []);
    commit("setQuery", {});
    commit("setIsOpen", false);
  },
  openSMSDialog({ commit }) {
    commit("setIsOpen", true);
  },
  openSMSDialogWithRecipients({ commit }, recipients) {
    commit("setRecipients", recipients);
    commit("setMode", "manual");
    commit("setIsOpen", true);
  },
  setSMSDialogRecipients({ commit }, recipients) {
    commit("setMode", "manual");
    commit("setRecipients", recipients);
  },
  openSMSDialogWithQuery({ commit }, query) {
    commit("setQuery", query);
    commit("setMode", "query");
    commit("setIsOpen", true);
  },
  setSMSDialogQuery({ commit }, query) {
    commit("setMode", "query");
    commit("setQuery", query);
  },
}

const mutations = {
  setIsOpen(state, isOpen) {
    state.isOpen = isOpen;
  },
  setMode(state, mode) {
    // valid values for `mode` are "manual" and "query"
    state.mode = mode;
  },
  setRecipients(state, recipients) {
    state.recipients = recipients;
  },
  setQuery(state, query) {
    state.query = query;
  },
}


export default {
  state,
  getters,
  actions,
  mutations,
}
